import { render } from "./RuleSwitchOffModalContent.vue?vue&type=template&id=54482724"
import script from "./RuleSwitchOffModalContent.vue?vue&type=script&lang=js"
export * from "./RuleSwitchOffModalContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleSwitchOffModalContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "54482724"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('54482724', __exports__)) {
    api.reload('54482724', __exports__)
  }
  
  module.hot.accept("./RuleSwitchOffModalContent.vue?vue&type=template&id=54482724", () => {
    api.rerender('54482724', render)
  })

}


export default __exports__